export default __webpack_public_path__ + "static/media/smartMonitoring.45df4b75.png";